import axios from 'axios'
if (process.env.NODE_ENV === 'production') {
    var BASE_URL = '/ai-course/api' // 这是正式的
} else {
    var BASE_URL = '/api' // 这是正式的
}

function getToken() {
    var token = localStorage.getItem('token')
    if (token) {
        return 'Bearer ' + token
    } else {
        return ''
    }
}

// create an axios instance
const service = axios.create({
    baseURL: BASE_URL, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 1000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    (config) => {
        config.headers['Authorization'] = getToken()
        return config
    },
    (error) => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    (response) => {
        const res = response.data
        return res
    },
    (error) => {
        window.toast && window.toast('网络连接失败,请检查网络是否正常')
        return Promise.reject(error)
    }
)

export default service

export function get(url, params) {
    return new Promise((resolve, reject) => {
        service({ url: url, method: 'get', params })
            .then((res) => {
                resolve(res)
            })
            .catch((e) => {
                reject()
            })
    })
}

export function post(url, data) {
    return new Promise((resolve, reject) => {
        service({ url: url, method: 'post', data })
            .then((res) => {
                resolve(res)
            })
            .catch((e) => {
                reject(e)
            })
    })
}

export function upload(url, data) {
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'post',
            data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((res) => {
                resolve(res)
            })
            .catch((e) => {
                reject(e)
            })
    })
}
